import { Layout } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import ModalComponent from "../components/formComponent/ModalComponent";
import FormSelect from "../components/general/FormSelect";
import ErrorBoundary from "../components/specificComponents/ErrorBoundary";
import { delay } from "../functions/generalFunctions";
import { getAllDataFromIDB } from "../functions/storage/getDataFromIDB";
import updateDataToIDB from "../functions/storage/updateDataToIDB";
import { changeCompany, signOut } from "../redux/actions/authAction";
import { SET_COLLAPSABLE } from "../redux/reduxConstants";
import HeaderLayout from "./Header";
import Sidebar from "./Sidebar";
import UnlockAudioModal from "../components/NewComponents/UnlockAudioModal";
import "./style.css";
import { MANAGEMENT } from "../common/SetupMasterEnum";

const isDashboardRoute = (pathname) => {
  if (pathname === "/" || pathname === "") return true;
  if (pathname === "/dashboard" || pathname === "/dashboardTwo") return true;
  if (pathname.startsWith("/dashboard/")) return true;
  if (pathname === "/g-dashboard" || pathname.startsWith("/g-dashboard/"))
    return true;
  return false;
};

const MainLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { CompanyId, companyList, collapsable, RoleName, RoleId } = useSelector(
    (state) => state.authReducer
  );
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  // const [collapsable, setCollapsable] = useState(false);

  useEffect(() => {
    if (CompanyId === null) {
      if (RoleName !== "Management" && RoleId !== MANAGEMENT) setShowCompanyModal(true);
    }
  }, [CompanyId]);

  const cancelCompanyModal = () => {
    delay(() => {
      dispatch(signOut(navigate));
      setShowCompanyModal(false);
    }, 500);
  };

  const handleOk = () => {
    if (companyId !== null) {
      let data = companyList.filter(
        (listItem) => listItem.CompanyId === companyId
      );
      getAllDataFromIDB("userData", (result) => {
        updateDataToIDB(
          "userData",
          result[0].id,
          {
            ...result[0],
            CompanyId: data[0].CompanyId,
            CompanyName: data[0].CompanyName,
          },
          () => {
            dispatch(changeCompany(data[0]));
            if (CompanyId !== null) {
              setShowCompanyModal(false);
            }
          }
        );
      });
    }
  };

  const toggleCollapse = useCallback(() => {
    dispatch({ type: SET_COLLAPSABLE, payload: !collapsable });
  }, [dispatch, collapsable]);

  useEffect(() => {
    if (RoleId !== MANAGEMENT || !isDashboardRoute(pathname)) return;

    const onKeyDown = (e) => {
      if (
        e.altKey &&
        e.ctrlKey &&
        (e.key === "s" || e.key === "S" || e.code === "KeyS")
      ) {
        e.preventDefault();
        navigate("/signup");
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [RoleId, pathname, navigate]);

  return (
    <div>
      <ModalComponent
        isModalVisible={showCompanyModal}
        handleCancel={cancelCompanyModal}
        handleOk={handleOk}
        okText="Proceed"
        cancelText="Sign Out"
        closable={false}
      >
        <h2>You're Super Admin :)</h2>
        <h3>Please Select a Company to continue...</h3>
        <br />
        <FormSelect
          value={companyId}
          onChange={(e) => {
            setCompanyId(e.value);
          }}
          listItem={companyList}
          idName="CompanyId"
          valueName="CompanyName"
          placeholder="Choose a Company"
        />
        <br />
        <span style={{ fontSize: 12, color: "gray" }}>
          Click anywhere on the screen to signout
        </span>
      </ModalComponent>
      {/* <HeaderLayout
          toggleCollapse={toggleCollapse}
          collapsable={collapsable}
        /> */}
      <Layout>

        <Layout style={{ display: "flex", flexDirection: "row" }}>
          <Sidebar collapsed={collapsable} />
          <Content
            className="content-container"
            style={{
              height: "Calc(100vh - 95px)",
              padding: "10px 10px 8px 10px",
              background: "#F8F8F8",
              overflow: "auto",
            }}
          >
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Content>
        </Layout>
        {/* <footer className="mainFooter">
          Powered by ygen © {new Date().getFullYear()} 
          <a href="/">
            <b></b>
          </a>
        </footer> */}
      </Layout>
    </div>
  );
};

export default MainLayout;
